<template>
  <!-- 图片与视频 -->
  <div class="brandList" id="preferredBrand-dynamics">
    <!-- 元素主体节点 -->
    <div
      class="listItem"
      v-for="(item, index) in brandList"
      :key="item.premiumCategoryId"
      :id="'preferredBrandFloor_' + index"
    >
      <!-- 标题节点 -->
      <div class="brandArea" :style="{ background: item.bgColor }">
        <!-- 中文名 -->
        <div class="categoryName">{{ item.name }}</div>
        <!-- 英文名 -->
        <div class="categorySubName">{{ item.nameEn }}</div>
      </div>
      <div class="brandList">
        <!-- 元素节点 -->
        <div
          class="brandItem"
          v-for="i in item.brandList"
          :key="i.premiumBrandId"
        >
          <div>
            <!-- 产品图 -->
            <div class="goodsImgArea">
              <el-image
                lazy
                :src="i.mainProductImgUrl || goodsDefaultImg"
                :fit="'contain'"
                class="goodsImg"
                alt="商品图片"
              />
              <!-- logo图 -->
              <el-image
                v-if="i.logoFileUrl"
                lazy
                :src="i.logoFileUrl"
                :fit="'contain'"
                class="logoImg"
                alt="logo"
              >
                <template #error>
                  <div></div>
                </template>
              </el-image>
            </div>
          </div>
          <!-- 标题 -->
          <div class="title ellipsis">{{ i.companyName }}</div>
          <!-- 描述 -->
          <div class="desc ellipsis-2">
            {{ i.introduce }}
          </div>
          <!-- 详情按钮 -->
          <div class="detailBtn" @click="toDetail(i)">
            <span>查看详情</span>
            <img
              class="arrow"
              src="~@/assets/img/preferredBrand/btn_arrow.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import goodsDefaultImg from "@/assets/img/bitmap.png";

export default {
  props: {
    brandList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      goodsDefaultImg,
    };
  },
  methods: {
    toDetail(res) {
      console.log(res);

      this.$router.push({
        name: "preferredBrand-info",
        query: {
          premiumBrandId: res.premiumBrandId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.brandList {
  margin-top: 180px;
  font-family: Alibaba PuHuiTi;

  .listItem {
    position: relative;
    padding-left: 48px;
    box-sizing: border-box;
    padding-bottom: 200px;
    height: 420px;
  }
  .brandArea {
    position: absolute;
    top: -100px;
    left: 0;
    width: 300px;
    height: 360px;
    border-radius: 16px;
    background: #291f96;
    z-index: 2;
    padding: 16px 24px;
    .categoryName {
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
    }
    .categorySubName {
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.54em;
      color: rgba(255, 255, 255, 0.6);
    }
  }
  .brandList {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 10px;
  }
  .brandItem {
    width: 272px;
    padding: 12px;
    border-radius: 16px;
    background: #f8f8fa;
    z-index: 10;
    margin-right: 20px;
    position: relative;
    &:last-child {
      margin-right: 0px;
    }
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #080404;
      margin-top: 20px;
      margin-bottom: 10px;
      height: 30px;
    }
    .desc {
      font-size: 14px;
      line-height: 24px;
      color: #797979;
      margin-bottom: 30px;
      height: 48px;
    }

    .detailBtn {
      display: none;
      width: 160px;
      height: 34px;
      font-size: 14px;
      line-height: 24px;
      text-align: left;
      color: #2a54d1;
      padding: 5px 24px;
      background-image: url("~@/assets/img/preferredBrand/btn_bg.png");
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      float: right;
      cursor: pointer;
      .arrow {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    &:hover .detailBtn {
      display: block;
    }
  }
  .goodsImgArea {
    border-radius: 8px;
    background: #e8e8eb;
    width: 248px;
    height: 200px;
    position: relative;
    .goodsImg {
      border-radius: 8px;
      width: 100%;
      height: 100%;
    }
    .logoImg {
      position: absolute;
      top: 8px;
      left: 8px;
      height: 40px;
    }
  }
}
.ellipsis-2 {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
